<div class="wrapper row" [attr.disabled]="disabled">
  <div
    class="svg-container"
    [attr.indeterminate]="indeterminate"
    [attr.checked]="checked"
    [attr.size]="size"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      *ngIf="checked == true"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="#4C64D9"
      />
      <path
        d="M8 18.3333L13 23L24 9"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      *ngIf="indeterminate === true"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="#4C64D9"
      />
      <path
        d="M10 16H22"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  </div>
  <!-- <input
    type="checkbox"
    hidden
    [formControl]="FormControl"
    [checked]="checked"
    (change)="onChange($event)"
  /> -->
  <div class="checkbox-text">
    <ng-content></ng-content>
  </div>
</div>
